import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appHelper from '../../../helpers/appHelper';
import * as userDataHelper from '../../../helpers/userDataHelper';
import * as appConstants from '../../../constants/appConstants';
import * as objectConstants from '../../../constants/objectConstants';
import {getAssetComponentByType} from '../../../helpers/componentHelper';
import * as keyboardConstants from '../../../constants/keyboardConstants';
import _ from 'lodash';

class VideoBtnMobile extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            userData: this.props.userData,
            object: this.props.object,
            activeObject: this.props.activeObject,
            enabledObjects: this.props.enabledObjects,
            completeObjects: this.props.completeObjects,
            focusedObject: this.props.focusedObject,
            className: "",
            locale: appHelper.getLocalData(this.props.object),
            update: false,
            renderedObject:{},
            video: {
                src: "",
                thumbnail: ""
            },
            autoPlay: false,
            nextObject: {},
            checkScrollPos: false,
            hideContinueAfterPressed: true,
        };
        this.setClass = this.setClass.bind(this);
        this.getAssets = this.getAssets.bind(this);
        this.onClicked = this.onClicked.bind(this);
        this.objectIsEnabled = this.objectIsEnabled.bind(this);
        this.objectIsComplete = this.objectIsComplete.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.getObjectStatus = this.getObjectStatus.bind(this);
        this.getObject = _.debounce(this.getObject.bind(this), 300);
        this.setNextObject = this.setNextObject.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);
        this.checkScrollPos = this.checkScrollPos.bind(this);

        this.videoBtn = React.createRef();
    }

    componentDidMount() {


        this.setClass();
        this.getAssets();
        if(appHelper.isDefined(this.state.object)) {
            this.getObject(this.state.object);
        }
    }

    componentWillReceiveProps(nextProps) {

        if (this.state.object !== nextProps.object) {
            this.setState({nextObject: Object.assign({}, nextProps.object)});
        }

        if (this.state.userData !== nextProps.userData) {
            this.setState({userData: Object.assign({}, nextProps.userData)});
        }

        if (this.state.activeObject !== nextProps.activeObject) {
            this.setState({
                activeObject: Object.assign({}, nextProps.activeObject),
                checkScrollPos:  appHelper.isDefined(nextProps.activeObject.data) &&appHelper.isDefined(nextProps.activeObject.data) && nextProps.activeObject.data.asset_id === this.state.object.asset_id && ((appHelper.isDefined(this.state.activeObject.data) && this.state.activeObject.data.asset_id !== nextProps.activeObject.data.asset_id) || !appHelper.isDefined(this.state.activeObject.data))
            });
        }
        if (this.state.enabledObjects !== nextProps.enabledObjects) {
            this.setState({enabledObjects: Object.assign([], nextProps.enabledObjects)});
        }
        if (this.state.completeObjects !== nextProps.completeObjects) {
            this.setState({completeObjects: Object.assign([], nextProps.completeObjects)});
        }

        if (this.state.focusedObject !== nextProps.focusedObject) {
            this.setState({focusedObject: Object.assign([], nextProps.focusedObject)});
        }

        if(this.state.lang !== nextProps.lang){
            let video = appHelper.getVideoAsset(this.state.object);
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.screen),
                video: appHelper.isDefined(video) && video.src.length > 0 ? video : this.state.video
            });
        }
    }

    componentDidUpdate() {
        if (this.state.update) {
            this.setClass();
        }

        if(appHelper.isDefined(this.state.nextObject.asset_id)){
            this.setNextObject();
        }

        if (this.state.checkScrollPos) {
            this.checkScrollPos();
        }

    }

    checkScrollPos(){
        //console.log(`checkScrollPos`);
        let isCurrent = appHelper.isDefined(this.state.activeObject.data) && this.state.activeObject.data.asset_id === this.state.object.asset_id;
        if(isCurrent) {
            let videoBtn = this.videoBtn.current;
            if (appHelper.isDefined(videoBtn) && videoBtn !== null) {
                let scrollPos = videoBtn.offsetTop;
                this.props.callbacks.scrollToVideo(scrollPos);
            }
            this.setState({
                checkScrollPos: false
            });
        }
    }

    getObject(object) {
        this.setState({
            renderedObject: Object.assign({}, {}),
            nextObject:object,
            //autoPlay: appHelper.getArrayObjectIndexByKey(this.state.screen.objects,"asset_id",object.asset_id) > 0
        });
    }

    setNextObject() {
        this.setState({nextObject: Object.assign({}, {})});
        let objectLocale = appHelper.getLocalData(this.state.nextObject);
        let objectType = Object.assign({}, getAssetComponentByType(objectLocale.asset_sub_type_code),
            {
                data: this.state.nextObject
            }
        );

        this.setState({renderedObject: Object.assign({}, objectType)});
    }

    getAssets() {
        let video = appHelper.getVideoAsset(this.props.object);
        video = appHelper.getLocalData(video);
        if (appHelper.isDefined(video) && video.src.length > 0) {
            this.setState({video: video});
        }
    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    getObjectStatus(){
        let objectUserData = {};
        let subScreenParent = this.props.callbacks.getSubScreenParent();
        let screen_id = this.props.callbacks.getScreenId();
        if (appHelper.isDefined(subScreenParent)) {
            objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.object.asset_id);
        } else if (this.state.isResourceObject) {
            objectUserData = userDataHelper.getResourceScreenObjectUserData(this.state.userData, screen_id, this.state.object.asset_id);
        } else {
            objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.object.asset_id);
        }

        return objectUserData.status;

    }

    objectIsEnabled() {
        return appHelper.getArrayObjectIndexByKey(this.state.enabledObjects, "asset_id", this.state.object.asset_id);
    }

    objectIsComplete() {
        return appHelper.getArrayObjectIndexByKey(this.state.completeObjects, "asset_id", this.state.object.asset_id);
    }


    setClass() {
        let className = "";

        if (appHelper.isDefined(this.state.activeObject.data) && this.state.activeObject.data.asset_id === this.state.object.asset_id) {
            className += "active ";
        }

        if (this.objectIsEnabled() === -1) {
            className += "disabled ";
        }

        /*if (this.objectIsComplete() > -1 || this.getObjectStatus() === objectConstants.STATUS_COMPLETE) {
            className += "complete ";
        } else {
            className += "incomplete ";
        }*/

        return className;
    }

    onClicked(event) {

       // event.preventDefault();
        event.stopPropagation();
        if (this.objectIsEnabled() > -1 ||  this.getObjectStatus() === objectConstants.STATUS_COMPLETE) {
            this.props.onClickFunc(this.state.object);
        }
    }

    setKeyboardAccessibility(event) {
        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            this.onClicked();
        }
    }

    render() {
        return (
            <div className={`video-btn ${this.setClass()}`} ref={this.videoBtn} onClick={this.onClicked} onKeyDown={this.setKeyboardAccessibility} role="presentation"  aria-current={appHelper.isDefined(this.state.activeObject.data) && this.state.activeObject.data.asset_id === this.state.object.asset_id} aria-disabled={this.objectIsEnabled() === -1}>
                {
                    appHelper.isDefined(this.state.renderedObject.data)
                        ?
                        <this.state.renderedObject.component
                            screenObject={this.state.renderedObject.data}
                            video={appHelper.getLocalData(appHelper.getVideoAsset(this.state.renderedObject.data))}
                            autoPlay={this.state.autoPlay}
                            hideContinueAfterPressed={this.state.hideContinueAfterPressed}
                            callbacks={this.props.callbacks}/>
                        :
                        null

                }
            </div>
        );

    }
}

VideoBtnMobile.propTypes = {
    object: PropTypes.object.isRequired,
    activeObject: PropTypes.object.isRequired,
    enabledObjects: PropTypes.array.isRequired,
    completeObjects: PropTypes.array.isRequired,
    callbacks: PropTypes.object.isRequired,
    userData: PropTypes.object.isRequired,
    onClickFunc: PropTypes.func,
    focusedObject: PropTypes.object,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object
};

VideoBtnMobile.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        userData: state.userData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, trackingDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(VideoBtnMobile);



/** WEBPACK FOOTER **
 ** ./src/components/screens/videoScreen/VideoBtnMobile.js
 **/